module.exports = __webpack_public_path__ + "img/15.071c481d.png";